// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1dnPZ","name":"ConsentHeader_name__F_5K-","birthday":"ConsentHeader_birthday__1ECZn","skeleton":"ConsentHeader_skeleton__3cdvf"};